import React from "react";
import { Linkedin, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { LINKEDIN_PERSONAL, LINKEDIN_COMPANY } from "../mock";

export default function About() {
  return (
    <section id="about" style={{ padding: "72px 0" }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="section-label">About</div>
              <h2 className="h-section" style={{ marginTop: 18 }}>
                A small, senior desk. <span className="serif" style={{ fontSize: "1.05em" }}>Run by hand.</span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={100}>
              <p style={{ fontSize: 18, lineHeight: 1.65, color: "var(--ink-soft)" }}>
                Conduit is run by <strong style={{ color: "var(--ink)", fontWeight: 600 }}>Vinay Viswanadh</strong>.
                After watching founders overpay agencies for outbound that a single sharp operator can run better, I
                built Conduit to deliver the same booked-meeting outcome as the big retainers, at roughly 40% of
                the price. Every list, sequence and reply is handled by hand, not a dashboard.
              </p>

              <div className="flex flex-wrap gap-3" style={{ marginTop: 28 }}>
                <a
                  href={LINKEDIN_PERSONAL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-ghost"
                >
                  <Linkedin size={16} /> Vinay on LinkedIn <ArrowUpRight size={14} />
                </a>
                <a
                  href={LINKEDIN_COMPANY}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-ghost"
                >
                  <Linkedin size={16} /> Conduit on LinkedIn <ArrowUpRight size={14} />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
